const Color = {
    primaryBackground: "#010625",
    secondaryBackground: "#D8D8E3",
    primaryText: "#EEEEEE",
    secondaryText: "#FFFFFF",
    thirdText: "#000000"
}

export default Color;